import * as room from './room'
import * as order from './order'

export default {
  room,
  order,
}
